/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { NumericEvaluationParameterDto } from './NumericEvaluationParameterDto';
import {
    NumericEvaluationParameterDtoFromJSON,
    NumericEvaluationParameterDtoFromJSONTyped,
    NumericEvaluationParameterDtoToJSON,
} from './NumericEvaluationParameterDto';
import type { NumericEvaluationResultDto } from './NumericEvaluationResultDto';
import {
    NumericEvaluationResultDtoFromJSON,
    NumericEvaluationResultDtoFromJSONTyped,
    NumericEvaluationResultDtoToJSON,
} from './NumericEvaluationResultDto';
import type { ResultHistoryEntryDto } from './ResultHistoryEntryDto';
import {
    ResultHistoryEntryDtoFromJSON,
    ResultHistoryEntryDtoFromJSONTyped,
    ResultHistoryEntryDtoToJSON,
} from './ResultHistoryEntryDto';

/**
 * 
 * @export
 * @interface NumericDataPointDetailsDto
 */
export interface NumericDataPointDetailsDto {
    /**
     * 
     * @type {Array<ResultHistoryEntryDto>}
     * @memberof NumericDataPointDetailsDto
     */
    history?: Array<ResultHistoryEntryDto> | null;
    /**
     * 
     * @type {NumericEvaluationResultDto}
     * @memberof NumericDataPointDetailsDto
     */
    evaluationResult: NumericEvaluationResultDto;
    /**
     * 
     * @type {NumericEvaluationParameterDto}
     * @memberof NumericDataPointDetailsDto
     */
    evaluationParameter: NumericEvaluationParameterDto;
    /**
     * 
     * @type {string}
     * @memberof NumericDataPointDetailsDto
     */
    $type?: NumericDataPointDetailsDtoTypeEnum;
}


/**
 * @export
 */
export const NumericDataPointDetailsDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedResultsDtoNumericDataPointDetailsDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.Results.Dto.NumericDataPointDetailsDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type NumericDataPointDetailsDtoTypeEnum = typeof NumericDataPointDetailsDtoTypeEnum[keyof typeof NumericDataPointDetailsDtoTypeEnum];


/**
 * Check if a given object implements the NumericDataPointDetailsDto interface.
 */
export function instanceOfNumericDataPointDetailsDto(value?: unknown): value is NumericDataPointDetailsDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(NumericDataPointDetailsDtoTypeEnum)[0];
}

export function NumericDataPointDetailsDtoFromJSON(json: any): NumericDataPointDetailsDto {
    return NumericDataPointDetailsDtoFromJSONTyped(json, false);
}

export function NumericDataPointDetailsDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): NumericDataPointDetailsDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'history': !exists(json, 'history') ? undefined : (json['history'] === null ? null : (json['history'] as Array<any>).map(ResultHistoryEntryDtoFromJSON)),
        'evaluationResult': NumericEvaluationResultDtoFromJSON(json['evaluationResult']),
        'evaluationParameter': NumericEvaluationParameterDtoFromJSON(json['evaluationParameter']),
        '$type': !exists(json, '$type') ? undefined : json['$type'],
    };
}

export function NumericDataPointDetailsDtoToJSON(value?: NumericDataPointDetailsDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'history': value.history === undefined ? undefined : (value.history === null ? null : (value.history as Array<any>).map(ResultHistoryEntryDtoToJSON)),
        'evaluationResult': NumericEvaluationResultDtoToJSON(value.evaluationResult),
        'evaluationParameter': NumericEvaluationParameterDtoToJSON(value.evaluationParameter),
        '$type': value.$type,
    });
}

